import state from './moduleWalletTransactionStatusState.js'
import mutations from './moduleWalletTransactionStatusMutations.js'
import actions from './moduleWalletTransactionStatusActions.js'
import getters from './moduleWalletTransactionStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
